export default "__VITE_ASSET__yX1jj9oC__"